// Left in place for backwards compatibility.  Import directly from @core/util instead.
module.exports = require('@core/util/clientlogger');
